// =============================================================================
//  Copyright : 2020 semantics GmbH
//  Date      : $Date: 2026-01-24 02:54:28 +0100 (Sat, 24 Jan 2026) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 159989 $
//  Purpose   : server log package
// =============================================================================
export const parts = true;
export const templates = true;
import * as actions from './actions';
export { actions };
import * as reducers from './reducers';
export { reducers };
